import { LightningElement, api, wire } from "lwc";

import { ContextAdapter, ContextAdapterValue } from "tds/contextAdapter";

import avatarPlaceholder from "./assets/astro-placeholder.svg";

const DEFAULT_COLOR = "#0070d2";

export default class extends LightningElement {
  @api assistiveText: string = "";
  @api variant: "user" | "org" = "user";
  @api imageVariant: "circle" | "rounded" | "square" = "circle";
  @api size: "small" | "medium" | "large" = "medium";
  @api imgSrc: string | null = null;
  @api color: string = DEFAULT_COLOR;
  @api loading: boolean | string | null = null;
  @api title: string = "";
  @api subtitle: string | null = null;
  @api titleHref: string | null = null;
  @api titleTarget: string | null = null;

  @wire(ContextAdapter)
  private context: ContextAdapterValue = null!;

  private get imgSrcWithDefault() {
    return this.imgSrc ?? `${this.context.assetsUrl}${avatarPlaceholder}`;
  }

  private get titleIsLink() {
    return !!this.titleHref;
  }

  private get isUser() {
    return this.variant === "user";
  }

  private get isOrg() {
    return this.variant === "org";
  }

  private get style() {
    return this.isOrg ? `background-color: ${this.color || DEFAULT_COLOR}` : "";
  }

  private get className() {
    return `avatar avatar--${this.size} avatar--${this.variant} avatar--${this.imageVariant}`;
  }

  private get isLoading() {
    return typeof this.loading === "boolean"
      ? this.loading
      : this.loading !== null;
  }

  private get containerClassName() {
    return this.title ? `flex align-items-center` : ``;
  }
}
